import locale77427e78 from '../../diptyqueTheme/lang/en.js'

export const Constants = {
  COMPONENT_OPTIONS_KEY: "nuxtI18n",
  STRATEGIES: {"PREFIX":"prefix","PREFIX_EXCEPT_DEFAULT":"prefix_except_default","PREFIX_AND_DEFAULT":"prefix_and_default","NO_PREFIX":"no_prefix"},
  REDIRECT_ON_OPTIONS: {"ALL":"all","ROOT":"root","NO_PREFIX":"no prefix"},
}
export const nuxtOptions = {
  isUniversalMode: true,
  trailingSlash: undefined,
}
export const options = {
  vueI18n: {"silentTranslationWarn":false,"silentFallbackWarn":false,"fallbackLocale":"en_eu","numberFormats":{"en_eu":{"currency":{"style":"currency","currency":"EUR","currencyDisplay":"symbol"}},"en_hk":{"currency":{"style":"currency","currency":"HKD","currencyDisplay":"symbol"}},"en_uk":{"currency":{"style":"currency","currency":"GBP","currencyDisplay":"symbol"}},"en_us":{"currency":{"style":"currency","currency":"USD","currencyDisplay":"symbol"}},"zh_hk":{"currency":{"style":"currency","currency":"HKD","currencyDisplay":"symbol"}},"fr_fr":{"currency":{"style":"currency","currency":"EUR","currencyDisplay":"symbol"}},"fr_us":{"currency":{"style":"currency","currency":"USD","currencyDisplay":"symbol"}},"fr_eu":{"currency":{"style":"currency","currency":"EUR","currencyDisplay":"symbol"}},"fr_ch":{"currency":{"style":"currency","currency":"EUR","currencyDisplay":"symbol"}},"es_eu":{"currency":{"style":"currency","currency":"EUR","currencyDisplay":"symbol"}},"it_eu":{"currency":{"style":"currency","currency":"EUR","currencyDisplay":"symbol"}},"it_ch":{"currency":{"style":"currency","currency":"EUR","currencyDisplay":"symbol"}},"de_eu":{"currency":{"style":"currency","currency":"EUR","currencyDisplay":"symbol"}},"de_ch":{"currency":{"style":"currency","currency":"EUR","currencyDisplay":"symbol"}},"ja_jp":{"currency":{"style":"currency","currency":"JPY","currencyDisplay":"symbol"}}}},
  vueI18nLoader: false,
  locales: [{"code":"en_eu","file":"en.js","iso":"en","languageLabel":"English","continent":"EU","websiteName":"International","defaultCurrency":"EUR","contentfulLocale":"en","storeview":"International: English","ctfFallbackLocales":["en"]},{"code":"en_hk","file":"en_hk.js","iso":"en-HK","languageLabel":"English","continent":"AS","websiteName":"Hong Kong","defaultCurrency":"HKD","contentfulLocale":"en-HK","storeview":"Hong Kong: English","ctfFallbackLocales":["en-HK","en"]},{"code":"en_uk","file":"en_gb.js","iso":"en-GB","languageLabel":"English","continent":"EU","websiteName":"United Kingdom","defaultCurrency":"GBP","contentfulLocale":"en-GB","storeview":"UK: English","ctfFallbackLocales":["en-GB","en"]},{"code":"en_us","file":"en_us.js","iso":"en-US","languageLabel":"English","continent":"NA","websiteName":"United States","defaultCurrency":"USD","contentfulLocale":"en-US","storeview":"USA: English","ctfFallbackLocales":["en-US","en"]},{"code":"zh_hk","file":"zh.js","iso":"zh","languageLabel":"Chinese","continent":"AS","websiteName":"Hong Kong","defaultCurrency":"HKD","contentfulLocale":"zh","storeview":"Hong Kong: Chinese","ctfFallbackLocales":["zh","en"]},{"code":"fr_fr","file":"fr.js","iso":"fr-FR","languageLabel":"Français","continent":"EU","websiteName":"France","defaultCurrency":"EUR","contentfulLocale":"fr","storeview":"France: French","ctfFallbackLocales":["fr","en"]},{"code":"fr_us","file":"fr.js","iso":"fr-CA","languageLabel":"Français","continent":"NA","websiteName":"Canada","defaultCurrency":"USD","contentfulLocale":"fr-CA","storeview":"USA: French","ctfFallbackLocales":["fr-CA","fr","en"]},{"code":"fr_us","file":"fr.js","iso":"fr-CA","languageLabel":"Français","continent":"NA","websiteName":"United States","defaultCurrency":"USD","contentfulLocale":"fr-CA","storeview":"USA: French","ctfFallbackLocales":["fr-CA","fr","en"]},{"code":"en_us","file":"en_us.js","iso":"en-US","languageLabel":"English","continent":"NA","websiteName":"Canada","defaultCurrency":"USD","contentfulLocale":"en-US","storeview":"USA: English","ctfFallbackLocales":["en-US","en"]},{"code":"fr_eu","file":"fr.js","iso":"fr-BE","languageLabel":"Français","continent":"EU","websiteName":"International","defaultCurrency":"EUR","contentfulLocale":"fr-BE","storeview":"International: French","ctfFallbackLocales":["fr-BE","fr","en"]},{"code":"es_eu","file":"es.js","iso":"es","languageLabel":"Español","continent":"EU","websiteName":"Spain","defaultCurrency":"EUR","contentfulLocale":"es","storeview":"International: Spanish","ctfFallbackLocales":["es","en"]},{"code":"it_eu","file":"it.js","iso":"it","languageLabel":"Italiano","continent":"EU","websiteName":"Italy","defaultCurrency":"EUR","contentfulLocale":"it","storeview":"International: Italian","ctfFallbackLocales":["it","en"]},{"code":"de_eu","file":"de.js","iso":"de","languageLabel":"Deutsch","continent":"EU","websiteName":"Germany","defaultCurrency":"EUR","contentfulLocale":"de","storeview":"International: Deutsch","ctfFallbackLocales":["de","en"]},{"code":"ja_jp","file":"ja.js","iso":"ja","languageLabel":"Japanese","continent":"AS","websiteName":"Japan","defaultCurrency":"JPY","contentfulLocale":"ja","storeview":"Japan: Japanese","ctfFallbackLocales":["ja","en"]}],
  defaultLocale: "en_eu",
  defaultDirection: "ltr",
  routesNameSeparator: "___",
  defaultLocaleRouteNameSuffix: "default",
  sortRoutes: true,
  strategy: "prefix",
  lazy: true,
  langDir: "diptyqueTheme/lang",
  rootRedirect: null,
  detectBrowserLanguage: false,
  differentDomains: false,
  baseUrl: "https://localhost:3000/",
  vuex: {"moduleName":"i18n","syncRouteParams":true},
  parsePages: true,
  pages: {},
  skipSettingLocaleOnNavigate: false,
  onBeforeLanguageSwitch: () => {},
  onLanguageSwitched: () => null,
  country: "US",
  autoChangeCookie: {"country":false},
  reloadOnLanguageChange: false,
  seo: true,
  normalizedLocales: [{"code":"en_eu","file":"en.js","iso":"en","languageLabel":"English","continent":"EU","websiteName":"International","defaultCurrency":"EUR","contentfulLocale":"en","storeview":"International: English","ctfFallbackLocales":["en"]},{"code":"en_hk","file":"en_hk.js","iso":"en-HK","languageLabel":"English","continent":"AS","websiteName":"Hong Kong","defaultCurrency":"HKD","contentfulLocale":"en-HK","storeview":"Hong Kong: English","ctfFallbackLocales":["en-HK","en"]},{"code":"en_uk","file":"en_gb.js","iso":"en-GB","languageLabel":"English","continent":"EU","websiteName":"United Kingdom","defaultCurrency":"GBP","contentfulLocale":"en-GB","storeview":"UK: English","ctfFallbackLocales":["en-GB","en"]},{"code":"en_us","file":"en_us.js","iso":"en-US","languageLabel":"English","continent":"NA","websiteName":"United States","defaultCurrency":"USD","contentfulLocale":"en-US","storeview":"USA: English","ctfFallbackLocales":["en-US","en"]},{"code":"zh_hk","file":"zh.js","iso":"zh","languageLabel":"Chinese","continent":"AS","websiteName":"Hong Kong","defaultCurrency":"HKD","contentfulLocale":"zh","storeview":"Hong Kong: Chinese","ctfFallbackLocales":["zh","en"]},{"code":"fr_fr","file":"fr.js","iso":"fr-FR","languageLabel":"Français","continent":"EU","websiteName":"France","defaultCurrency":"EUR","contentfulLocale":"fr","storeview":"France: French","ctfFallbackLocales":["fr","en"]},{"code":"fr_us","file":"fr.js","iso":"fr-CA","languageLabel":"Français","continent":"NA","websiteName":"Canada","defaultCurrency":"USD","contentfulLocale":"fr-CA","storeview":"USA: French","ctfFallbackLocales":["fr-CA","fr","en"]},{"code":"fr_us","file":"fr.js","iso":"fr-CA","languageLabel":"Français","continent":"NA","websiteName":"United States","defaultCurrency":"USD","contentfulLocale":"fr-CA","storeview":"USA: French","ctfFallbackLocales":["fr-CA","fr","en"]},{"code":"en_us","file":"en_us.js","iso":"en-US","languageLabel":"English","continent":"NA","websiteName":"Canada","defaultCurrency":"USD","contentfulLocale":"en-US","storeview":"USA: English","ctfFallbackLocales":["en-US","en"]},{"code":"fr_eu","file":"fr.js","iso":"fr-BE","languageLabel":"Français","continent":"EU","websiteName":"International","defaultCurrency":"EUR","contentfulLocale":"fr-BE","storeview":"International: French","ctfFallbackLocales":["fr-BE","fr","en"]},{"code":"es_eu","file":"es.js","iso":"es","languageLabel":"Español","continent":"EU","websiteName":"Spain","defaultCurrency":"EUR","contentfulLocale":"es","storeview":"International: Spanish","ctfFallbackLocales":["es","en"]},{"code":"it_eu","file":"it.js","iso":"it","languageLabel":"Italiano","continent":"EU","websiteName":"Italy","defaultCurrency":"EUR","contentfulLocale":"it","storeview":"International: Italian","ctfFallbackLocales":["it","en"]},{"code":"de_eu","file":"de.js","iso":"de","languageLabel":"Deutsch","continent":"EU","websiteName":"Germany","defaultCurrency":"EUR","contentfulLocale":"de","storeview":"International: Deutsch","ctfFallbackLocales":["de","en"]},{"code":"ja_jp","file":"ja.js","iso":"ja","languageLabel":"Japanese","continent":"AS","websiteName":"Japan","defaultCurrency":"JPY","contentfulLocale":"ja","storeview":"Japan: Japanese","ctfFallbackLocales":["ja","en"]}],
  localeCodes: ["en_eu","en_hk","en_uk","en_us","zh_hk","fr_fr","fr_us","fr_us","en_us","fr_eu","es_eu","it_eu","de_eu","ja_jp"],
  additionalMessages: [],
}
export const localeFiles = {
  0: "{",
  1: "\"",
  2: "e",
  3: "n",
  4: ".",
  5: "j",
  6: "s",
  7: "\"",
  8: ":",
  9: "\"",
  10: ".",
  11: ".",
  12: "/",
  13: "d",
  14: "i",
  15: "p",
  16: "t",
  17: "y",
  18: "q",
  19: "u",
  20: "e",
  21: "T",
  22: "h",
  23: "e",
  24: "m",
  25: "e",
  26: "/",
  27: "l",
  28: "a",
  29: "n",
  30: "g",
  31: "/",
  32: "e",
  33: "n",
  34: ".",
  35: "j",
  36: "s",
  37: "\"",
  38: ",",
  39: "\"",
  40: "e",
  41: "n",
  42: "_",
  43: "h",
  44: "k",
  45: ".",
  46: "j",
  47: "s",
  48: "\"",
  49: ":",
  50: "\"",
  51: ".",
  52: ".",
  53: "/",
  54: "d",
  55: "i",
  56: "p",
  57: "t",
  58: "y",
  59: "q",
  60: "u",
  61: "e",
  62: "T",
  63: "h",
  64: "e",
  65: "m",
  66: "e",
  67: "/",
  68: "l",
  69: "a",
  70: "n",
  71: "g",
  72: "/",
  73: "e",
  74: "n",
  75: "_",
  76: "h",
  77: "k",
  78: ".",
  79: "j",
  80: "s",
  81: "\"",
  82: ",",
  83: "\"",
  84: "e",
  85: "n",
  86: "_",
  87: "g",
  88: "b",
  89: ".",
  90: "j",
  91: "s",
  92: "\"",
  93: ":",
  94: "\"",
  95: ".",
  96: ".",
  97: "/",
  98: "d",
  99: "i",
  100: "p",
  101: "t",
  102: "y",
  103: "q",
  104: "u",
  105: "e",
  106: "T",
  107: "h",
  108: "e",
  109: "m",
  110: "e",
  111: "/",
  112: "l",
  113: "a",
  114: "n",
  115: "g",
  116: "/",
  117: "e",
  118: "n",
  119: "_",
  120: "g",
  121: "b",
  122: ".",
  123: "j",
  124: "s",
  125: "\"",
  126: ",",
  127: "\"",
  128: "e",
  129: "n",
  130: "_",
  131: "u",
  132: "s",
  133: ".",
  134: "j",
  135: "s",
  136: "\"",
  137: ":",
  138: "\"",
  139: ".",
  140: ".",
  141: "/",
  142: "d",
  143: "i",
  144: "p",
  145: "t",
  146: "y",
  147: "q",
  148: "u",
  149: "e",
  150: "T",
  151: "h",
  152: "e",
  153: "m",
  154: "e",
  155: "/",
  156: "l",
  157: "a",
  158: "n",
  159: "g",
  160: "/",
  161: "e",
  162: "n",
  163: "_",
  164: "u",
  165: "s",
  166: ".",
  167: "j",
  168: "s",
  169: "\"",
  170: ",",
  171: "\"",
  172: "z",
  173: "h",
  174: ".",
  175: "j",
  176: "s",
  177: "\"",
  178: ":",
  179: "\"",
  180: ".",
  181: ".",
  182: "/",
  183: "d",
  184: "i",
  185: "p",
  186: "t",
  187: "y",
  188: "q",
  189: "u",
  190: "e",
  191: "T",
  192: "h",
  193: "e",
  194: "m",
  195: "e",
  196: "/",
  197: "l",
  198: "a",
  199: "n",
  200: "g",
  201: "/",
  202: "z",
  203: "h",
  204: ".",
  205: "j",
  206: "s",
  207: "\"",
  208: ",",
  209: "\"",
  210: "f",
  211: "r",
  212: ".",
  213: "j",
  214: "s",
  215: "\"",
  216: ":",
  217: "\"",
  218: ".",
  219: ".",
  220: "/",
  221: "d",
  222: "i",
  223: "p",
  224: "t",
  225: "y",
  226: "q",
  227: "u",
  228: "e",
  229: "T",
  230: "h",
  231: "e",
  232: "m",
  233: "e",
  234: "/",
  235: "l",
  236: "a",
  237: "n",
  238: "g",
  239: "/",
  240: "f",
  241: "r",
  242: ".",
  243: "j",
  244: "s",
  245: "\"",
  246: ",",
  247: "\"",
  248: "e",
  249: "s",
  250: ".",
  251: "j",
  252: "s",
  253: "\"",
  254: ":",
  255: "\"",
  256: ".",
  257: ".",
  258: "/",
  259: "d",
  260: "i",
  261: "p",
  262: "t",
  263: "y",
  264: "q",
  265: "u",
  266: "e",
  267: "T",
  268: "h",
  269: "e",
  270: "m",
  271: "e",
  272: "/",
  273: "l",
  274: "a",
  275: "n",
  276: "g",
  277: "/",
  278: "e",
  279: "s",
  280: ".",
  281: "j",
  282: "s",
  283: "\"",
  284: ",",
  285: "\"",
  286: "i",
  287: "t",
  288: ".",
  289: "j",
  290: "s",
  291: "\"",
  292: ":",
  293: "\"",
  294: ".",
  295: ".",
  296: "/",
  297: "d",
  298: "i",
  299: "p",
  300: "t",
  301: "y",
  302: "q",
  303: "u",
  304: "e",
  305: "T",
  306: "h",
  307: "e",
  308: "m",
  309: "e",
  310: "/",
  311: "l",
  312: "a",
  313: "n",
  314: "g",
  315: "/",
  316: "i",
  317: "t",
  318: ".",
  319: "j",
  320: "s",
  321: "\"",
  322: ",",
  323: "\"",
  324: "d",
  325: "e",
  326: ".",
  327: "j",
  328: "s",
  329: "\"",
  330: ":",
  331: "\"",
  332: ".",
  333: ".",
  334: "/",
  335: "d",
  336: "i",
  337: "p",
  338: "t",
  339: "y",
  340: "q",
  341: "u",
  342: "e",
  343: "T",
  344: "h",
  345: "e",
  346: "m",
  347: "e",
  348: "/",
  349: "l",
  350: "a",
  351: "n",
  352: "g",
  353: "/",
  354: "d",
  355: "e",
  356: ".",
  357: "j",
  358: "s",
  359: "\"",
  360: ",",
  361: "\"",
  362: "j",
  363: "a",
  364: ".",
  365: "j",
  366: "s",
  367: "\"",
  368: ":",
  369: "\"",
  370: ".",
  371: ".",
  372: "/",
  373: "d",
  374: "i",
  375: "p",
  376: "t",
  377: "y",
  378: "q",
  379: "u",
  380: "e",
  381: "T",
  382: "h",
  383: "e",
  384: "m",
  385: "e",
  386: "/",
  387: "l",
  388: "a",
  389: "n",
  390: "g",
  391: "/",
  392: "j",
  393: "a",
  394: ".",
  395: "j",
  396: "s",
  397: "\"",
  398: "}",
}

export const localeMessages = {
  'en.js': () => Promise.resolve(locale77427e78),
  'en_hk.js': () => import('../../diptyqueTheme/lang/en_hk.js' /* webpackChunkName: "lang-en_hk.js" */),
  'en_gb.js': () => import('../../diptyqueTheme/lang/en_gb.js' /* webpackChunkName: "lang-en_gb.js" */),
  'en_us.js': () => import('../../diptyqueTheme/lang/en_us.js' /* webpackChunkName: "lang-en_us.js" */),
  'zh.js': () => import('../../diptyqueTheme/lang/zh.js' /* webpackChunkName: "lang-zh.js" */),
  'fr.js': () => import('../../diptyqueTheme/lang/fr.js' /* webpackChunkName: "lang-fr.js" */),
  'es.js': () => import('../../diptyqueTheme/lang/es.js' /* webpackChunkName: "lang-es.js" */),
  'it.js': () => import('../../diptyqueTheme/lang/it.js' /* webpackChunkName: "lang-it.js" */),
  'de.js': () => import('../../diptyqueTheme/lang/de.js' /* webpackChunkName: "lang-de.js" */),
  'ja.js': () => import('../../diptyqueTheme/lang/ja.js' /* webpackChunkName: "lang-ja.js" */),
}
